
// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://ndqudoynysmynztrepwj.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im5kcXVkb3lueXNteW56dHJlcHdqIiwicm9sZSI6ImFub24iLCJpYXQiOjE3Mzc0NTk2NzYsImV4cCI6MjA1MzAzNTY3Nn0.NfTdxUlkGfcG2pWxLrlIwEUFIyhE2NosM-71RrEqVrw";

// Track if we've already created a client
let clientCreated = false;

// HMR-safe singleton pattern using window object to survive hot reloads
declare global {
  interface Window {
    __supabaseClient?: ReturnType<typeof createClient<Database>>;
  }
}

// Lazy client getter to ensure true singleton
const getSupabaseClient = (): ReturnType<typeof createClient<Database>> => {
  // Check if client already exists on window (survives HMR)
  if (typeof window !== 'undefined' && window.__supabaseClient) {
    return window.__supabaseClient;
  }

  // Prevent double instantiation during module load
  if (clientCreated) {
    console.warn('⚠️ [Supabase] Attempted to create client multiple times');
    if (window.__supabaseClient) {
      return window.__supabaseClient;
    }
    throw new Error('Supabase client already being created');
  }

  clientCreated = true;

  // Create new client instance
  const client = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
    auth: {
      storage: localStorage,
      storageKey: 'sb-ndqudoynysmynztrepwj-auth-token',
      persistSession: true,
      autoRefreshToken: true,
      detectSessionInUrl: true,
      flowType: 'pkce',
    }
  });

  // Store on window object to survive HMR
  if (typeof window !== 'undefined') {
    window.__supabaseClient = client;
  }

  return client;
};

// Create a proxy that lazily initializes the client
export const supabase = new Proxy({} as ReturnType<typeof createClient<Database>>, {
  get(target, prop) {
    // Enhanced debug logging to track what triggers client initialization
    if (!window.__supabaseClient) {
      console.log('🟢 [Supabase Main Client] First initialization - property:', prop);
      console.log('🟢 [Supabase Main Client] Route:', window.location.pathname);
      console.log('🟢 [Supabase Main Client] Timestamp:', new Date().toISOString());
    }
    const client = getSupabaseClient();
    const value = client[prop as keyof typeof client];
    return typeof value === 'function' ? value.bind(client) : value;
  }
});

// Export the QueryTemplate type
export interface QueryTemplate {
  id: string;
  name: string;
  description: string;
  query: string;
  category: string;
  ai_workflow: string | null;
  ai_model?: string | null;
  data_tags: string[] | null;
  organization_id?: string | null;
  created_at: string;
}
